import { Outlet } from 'react-router';

// UI
import { NotificationProvider } from '@store/notifications';
import Notifications from '@components/notifications-list';

const NotificationsLayout = () => {
  return (
    <NotificationProvider>
      <Outlet />
      <Notifications />
    </NotificationProvider>
  );
};

export default NotificationsLayout;
